import { ContentEdge } from "@/shared/services/graphql/generated/consumer-graph-types.ts";
import { Documentation } from "@/shared/documentation/documentation.types.ts";
import { GetDataDisplayPropertiesByConfig } from "@/shared/data-display-config/composable/data-display-config.ts";
import {
    ContentNode,
    mapContentNodeToDocumentationBase,
    withRootVersionLabel,
} from "@/shared/documentation/mapper/content-node.mapper.ts";

export const mapContentEdgesToDocumentModel = (
    contentEdges: ContentEdge[],
    getDataDisplayPropertiesByConfig?: GetDataDisplayPropertiesByConfig
): Documentation[] => {
    return contentEdges
        .map((entry): Documentation | undefined => {
            if (!entry || !entry.node) return;

            const node = entry.node as ContentNode;
            const language = node.language ?? node.locale?.substring(0, 2) ?? "";
            const rootContentMapTitle =
                node.__typename === "Topic" ? (node.useContext?.rootContentMap?.teasers?.title ?? "") : undefined;

            return {
                ...mapContentNodeToDocumentationBase(
                    node,
                    entry.cursor ?? "",
                    language,
                    getDataDisplayPropertiesByConfig
                ),
                rootContentMapTitle,
                mimeType: node.mimeType ?? undefined,
                highlightTitle: entry.highlights?.title as string[] | undefined,
                highlightText: entry.highlights?.text as string[] | undefined,
                products: node.useContext?.custom_products ?? undefined,
                version: node.version ?? undefined,
                versionLabel: withRootVersionLabel(node).versionLabel ?? undefined,
            };
        })
        .filter((document) => document !== undefined);
};
